import React, { Fragment, useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { API_URL } from "../../../../utils/const";
import { useAxios } from "../../../../utils/const";
import { useForm } from "react-hook-form";
import { TitleContext } from "../../../../Context/TitleContext";

const LogbookList = () => {
  const axiosInstance = useAxios();
  const form = useForm({});
  const { register, setValue } = form;
  const [logbooks, setLogbooks] = useState([]);
  const [userId, setUserId] = useState(null);
  const { setTitle } = useContext(TitleContext);
  const [nilaiAkhir, setNilaiAkhir] = useState("");
  const [nilaiProses, setNilaiProses] = useState("");
  const [courseSession, setCourseSession] = useState([]);

  const { id, course_type } = useParams();

  useEffect(() => {
    setTitle("USAKTI | Data Kehadiran Mahasiswa"); // Set judul halaman
  }, [setTitle]);

  const getUserById = async () => {
    const response = await axiosInstance.get(`${API_URL}/users/find-by/token`);
    setUserId(response.data.data.id);
  };

  const getPenilaianLogbook = async () => {
    const data = {
      course_group_timetable_tutorial_id: id,
      student_id: userId,
    };

    const response = await axiosInstance.post(
      `${API_URL}/tutorial-penilaian-logbook/find`,
      data
    );

    if (response.data.data.tutorialLogbookScore != null) {
      const tutorialLogbookScore = response.data.data.tutorialLogbookScore;
      setValue(
        "kelengkapan",
        tutorialLogbookScore.kelengkapan
          ? tutorialLogbookScore.kelengkapan.toString()
          : "0"
      );
      setValue(
        "kejelasan",
        tutorialLogbookScore.kejelasan
          ? tutorialLogbookScore.kejelasan.toString()
          : ""
      );
      setValue(
        "referensi",
        tutorialLogbookScore.referensi
          ? tutorialLogbookScore.referensi.toString()
          : ""
      );
      setValue(
        "sasaran",
        tutorialLogbookScore.sasaran
          ? tutorialLogbookScore.sasaran.toString()
          : ""
      );
      setValue(
        "kemampuan",
        tutorialLogbookScore.kemampuan
          ? tutorialLogbookScore.kemampuan.toString()
          : ""
      );
      setValue(
        "tanggapan",
        tutorialLogbookScore.tanggapan ? tutorialLogbookScore.tanggapan : "-"
      );
      setNilaiAkhir(tutorialLogbookScore.final_score);
    }

    setLogbooks(response.data.data.tutorialLogbooks);
  };

  const getPenilaianProses = async () => {
    const response = await axiosInstance.get(
      `${API_URL}/course-students/${id}/${course_type}`
    );

    const studentsData = response.data.data.students;

    if (studentsData) {
      const filteredStudent = studentsData.find(
        (student) => student.student_id === userId
      );
      if (filteredStudent) {
        const nilaiProses =
          filteredStudent.courseGroupTimetableTutorial.tutorialSesi.tutorial
            .tutorialPenilaianProses[0];
        if (nilaiProses) {
          setValue("tanggapan_proses", nilaiProses.tanggapan);
          setNilaiProses(parseFloat(nilaiProses.final_score).toFixed(1));
        }
      }
    }
  };

  const getCourseSession = async () => {
    const response = await axiosInstance.get(
      `${API_URL}/course-sessions/${id}/${course_type}`
    );
    setCourseSession(response.data.data);
  };

  useEffect(() => {
    getUserById();
    getCourseSession();
  }, []);

  useEffect(() => {
    if (userId) {
      getPenilaianLogbook();
      if (course_type === "TUTORIAL (SESI 1)") {
        getPenilaianProses();
      }
    }
  }, [userId, course_type]);

  return id ? (
    <div>
      <Toaster position="top-right" />
      <div className="container-fluid">
        <div className="card mb-4">
          <div className="card-body">
            <h1>Logbook</h1>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <Link>Daftar Modul</Link>
              </li>
              <li className="breadcrumb-item active">
                <Link>Data Kehadiran Mahasiswa</Link>
              </li>
              <li className="breadcrumb-item active">Logbook</li>
            </ol>
          </div>
        </div>

        <div className="card">
          <div className="card-body m-3">
            <div className="row mt-3">
              <div className="col-md-12 text-start table-responsive">
                <table style={{ width: "650px" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "175px" }}>Modul</td>
                      <td>
                        :{" "}
                        {courseSession?.courseGroup?.course?.name?.replace(
                          /\s*\(.*?\)/g,
                          ""
                        ) || "-"}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ width: "175px" }}>Topik</td>
                      <td>: {courseSession?.courseTopic?.topic || "-"}</td>
                    </tr>
                    <tr>
                      <td style={{ width: "175px" }}>Kode MK</td>
                      <td>
                        :{" "}
                        {courseSession?.courseGroup?.course?.name?.match(
                          /\((.*?)\)/
                        )?.[1] || "-"}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ width: "175px" }}>Tipe Kelas</td>
                      <td>: {courseSession?.course_type || "-"}</td>
                    </tr>
                    <tr>
                      <td style={{ width: "175px" }}>Kelompok Modul</td>
                      <td>
                        : {courseSession?.courseGroup?.group?.name || "-"}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <hr />
            <div className="row text-center mt-3 mb-3">
              {logbooks.map((item) => (
                <>
                  <div
                    className="col-md-4 d-flex"
                    style={{
                      marginLeft: "30px",
                      alignItems: "flex-start", // Membuat elemen di dalam div rata kiri
                      flexDirection: "column", // Mengatur arah vertikal (atas-bawah)
                    }}
                  >
                    <i
                      className="fas fa-file-pdf text-danger"
                      style={{ fontSize: "50px" }}
                    ></i>

                    <a
                      href={`${API_URL}/public/logbooks/${item.file}`}
                      className="text-uppercase"
                      style={{
                        marginTop: "10px", // Memberi jarak antara ikon dan teks
                        fontSize: "15px",
                      }}
                      download
                    >
                      {item.file}
                    </a>
                  </div>
                </>
              ))}
            </div>

            {course_type === "TUTORIAL (SESI 1)" && (
              <Fragment>
                {/** TANGGAPAN */}
                <div class="row mb-3">
                  <div class="col-md-12 mb-3">
                    <div class="form-group">
                      <label for="update_tanggapan_tutorial" class="form-label">
                        Tanggapan
                      </label>
                      <textarea
                        name="tanggapan_proses"
                        {...register("tanggapan_proses")}
                        id="update_tanggapan_tutorial"
                        rows="2"
                        disabled
                        class="form-control"
                      ></textarea>
                    </div>
                  </div>
                </div>

                {/** RUMUS NILAI */}
                <div class="row mb-3">
                  <h5>
                    <strong class="text-decoration-underline">
                      NILAI AKHIR : {nilaiProses ? nilaiProses : "-"}
                    </strong>
                  </h5>
                </div>
              </Fragment>
            )}

            {course_type === "TUTORIAL (SESI 2)" && (
              <Fragment>
                <div className="row mt-3 text-center">
                  <h5>
                    <strong style={{ textDecoration: "underline" }}>
                      RUBRIK PENILAIAN LOGBOOK DISKUSI TUTORIAL MAHASISWA
                    </strong>
                  </h5>
                </div>
                <div className="row mb-3">
                  <div className="row mb-3">
                    <div className="col-md-12 mb-3">
                      <div className="form-group">
                        <label
                          htmlFor="update_tanggapan_logbook"
                          className="form-label"
                        >
                          Tanggapan
                        </label>
                        <textarea
                          {...register("tanggapan")}
                          name="tanggapan_logbook"
                          id="update_tanggapan_logbook"
                          rows="2"
                          className="form-control"
                          disabled
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="d-flex justify-content-between">
                      <h5>
                        <strong className="text-decoration-underline">
                          NILAI AKHIR : {nilaiAkhir ? nilaiAkhir : "-"}
                        </strong>
                      </h5>
                    </div>
                  </div>
                </div>
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div>
      <div className="row">
        <div
          className="col-md-12 text-center align-center"
          style={{ marginTop: "20%" }}
        >
          <h1>Mohon Tunggu</h1>
        </div>
      </div>
    </div>
  );
};

export default LogbookList;
